import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function FormFieldError({ children }: Props): JSX.Element {
  return <p className='text-red-500 text-xs pt-1'>{children}</p>;
}
